import React, { ReactElement } from 'react'
import ErrorTemplate from '../templates/ErrorTemplate'
import { iconError } from '../../assets/images/images'

const Error500 = (): ReactElement => {
  return (
    <ErrorTemplate>
      <>
        <img src={iconError} alt="Problem Icon" />
        <div className="mt25">
          <h1 className="errorPageTitle">
            Le site web ne parvient pas à <br />
            afficher cette page.
          </h1>
          <p className="mt5 mb5 fontWeightBold fontSizeXs lh16">
            Il se peut que le site soit en cours de maintenance ou qu&apos;une
            erreur de programmation se soit produite.
          </p>
        </div>
      </>
    </ErrorTemplate>
  )
}

export default Error500
